import './SummaryBlock.less';
import React, {useState, useEffect} from 'react';
import getAttributeCheckboxItems from "../utils/getAttributeCheckboxItems";
import isAttributeCheckboxItemSelected from "../utils/isAttributeCheckboxItemSelected";
import __ from "../../../../i18n";
import isBeforePriceRangeGroup from "../utils/isBeforePriceRangeGroup";
import Icon from "../../../../components/icon/Icon";


export default function SummaryBlock(
    {
        attributeGroups,
        attributes,
        groupedAttributeIds,
        patchGroupAttributeIds,
        clearGroupedAttributeIds,
        priceRange,
        applyPriceRange,
        onNumberOfItemsChange = () => {}
    }
) {

    const getAttributeSummaryItems = () => {
        const attributeSummaryItems = [];

        for (let key in groupedAttributeIds) {
            if (groupedAttributeIds.hasOwnProperty(key)) {
                const groupId = key;
                const selectedAttributeIds = groupedAttributeIds[key];
                const group = attributeGroups.find(t => String(t.id) === String(groupId));
                const checkboxItems = getAttributeCheckboxItems(group, attributes);
                const selectedCheckboxItems = checkboxItems.filter(item => isAttributeCheckboxItemSelected(item, selectedAttributeIds));

                attributeSummaryItems.push(...selectedCheckboxItems.map(t => ({
                    name: __(':field: :value', {field: group.name, value: t.name}),
                    deselect: () => patchGroupAttributeIds(groupId, selectedAttributeIds.filter(sel => !t.value.includes(sel))),
                    isBeforePrice: isBeforePriceRangeGroup(group),
                })));
            }
        }

        return attributeSummaryItems;
    }

    const getPriceSummaryText = () => {
        const [min, max] = priceRange;

        if (min === null && max === null) {
            return null;
        }

        if (min === null) {
            return __('Max price: :max(CURRENCY, symbol)', {max});
        }

        if (max === null) {
            return __('Min price: :min(CURRENCY, symbol)', {min});
        }

        return __('Price: :min(CURRENCY, symbol) - :max(CURRENCY, symbol)', {min, max});
    };

    const deselectPrice = () => {
        applyPriceRange([null, null]);
    };

    const deselectAll = () => {
        clearGroupedAttributeIds();
        deselectPrice();
    };

    const [attributeSummaryItems, setAttributeSummaryItems] = useState([]);

    const [priceSummaryText, setPriceSummaryText] = useState(null);

    const [shouldDelay, setShouldDelay] = useState(true);

    useEffect(() => {
        if (!shouldDelay) {
            setAttributeSummaryItems(getAttributeSummaryItems());
            setShouldDelay(true);
            return;
        }

        setTimeout(() => {
            setAttributeSummaryItems(getAttributeSummaryItems());
        }, 200);

    }, [attributeGroups, attributes, groupedAttributeIds]);

    useEffect(() => {
        if (!shouldDelay) {
            setPriceSummaryText(getPriceSummaryText());
            setShouldDelay(true);
            return;
        }

        setTimeout(() => {
            setPriceSummaryText(getPriceSummaryText());
        }, 200);

    }, [priceRange]);

    const countSummaryItems = () => {
        return attributeSummaryItems.length + (priceSummaryText === null ? 0 : 1);
    };

    useEffect(() => {
        onNumberOfItemsChange(countSummaryItems());
    }, [countSummaryItems()]);

    if (countSummaryItems() === 0) {
        return null;
    }

    const renderSummaryItem = (t) => {
        return <div className="summary-item" key={t.name}>
            <div className="text">{t.name}</div>
            <button
                type="button"
                onClick={() => {
                    setShouldDelay(false);
                    t.deselect();
                }}
            >
                <Icon name="times-circle"/>
            </button>
        </div>;
    };

    return <div className="summary-block">
        {
            attributeSummaryItems
                .filter(t => t.isBeforePrice)
                .map(renderSummaryItem)
        }
        {
            priceSummaryText !== null &&
            renderSummaryItem({
                name: priceSummaryText,
                deselect: () => {
                    setShouldDelay(false);
                    deselectPrice();
                }
            })
        }
        {
            attributeSummaryItems
                .filter(t => !t.isBeforePrice)
                .map(renderSummaryItem)
        }
        <div className="clear-wrapper">
            <span
                className="clearer"
                onClick={() => {
                    setShouldDelay(false);
                    deselectAll();
                }}
            >
                {__('Clear all filters')}
            </span>
        </div>
    </div>;
}
